import api from '../instance'

export function getProviders() {
  return api.get(`/providers`)
}
